import React from "react";

const Skeleton = ({ height }) => {
  return (
    <div
      style={{
        height: `${height}px`,
        width: "100%",
        backgroundColor: "#e0e0e0",
        borderRadius: "4px",
        marginBottom: "10px",
      }}
    />
  );
};

export default Skeleton;
